import React, { useState } from "react";
import { Table, Button, Input } from "antd";
import { Edit, Trash2 } from "lucide-react";
import { LeftOutlined, BulbOutlined, PlusOutlined } from "@ant-design/icons";

import EventModal from "../../../../../modal/admin/addEventModal";

const Event = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Sample event data - replace with actual data from your backend
  const events = [
    {
      id: "E001",
      title: "Annual Conference",
      location: "Grand Hotel",
      time: "2024-02-15 09:00 AM",
      createdDate: "2024-01-20",
    },
    {
      id: "E002",
      title: "Team Building Workshop",
      location: "Adventure Park",
      time: "2024-02-20 10:00 AM",
      createdDate: "2024-01-21",
    },
  ];

  const columns = [
    {
      title: "Event Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: "Event Location",
      dataIndex: "location",
      key: "location",
      sorter: (a, b) => a.location.localeCompare(b.location),
    },
    {
      title: "Event Time",
      dataIndex: "time",
      key: "time",
      sorter: (a, b) => new Date(a.time) - new Date(b.time),
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      sorter: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex gap-2">
          <Button
            type="text"
            icon={<Edit className="w-4 h-4 text-blue-600" />}
            onClick={() => console.log("Edit")}
          />
          <Button
            type="text"
            icon={<Trash2 className="w-4 h-4 text-red-600" />}
            onClick={() => console.log("Delete")}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="px-4 pt-2 pb-4 flex flex-col gap-5 bg-white rounded-md">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold mb-4">Event</h2>
        <div className="flex justify-between items-center gap-2">
          <Button icon={<LeftOutlined />}>Back</Button>

          <Button icon={<BulbOutlined />}>Page Tip</Button>
        </div>
      </div>
      <div className="flex  gap-4 items-center mb-6">
        <Input.Search
          placeholder="Search events..."
          style={{ width: 300 }}
          className="mr-4"
        />

        <Button
          type="primary"
          icon={<PlusOutlined />}
          className="bg-primary text-white"
          onClick={() => setIsModalOpen(true)}
        >
          Add Event
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={events}
        rowKey="id"
        scroll={{ x: 'max-content' }}
          pagination={{
          total: events.length,
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} items`,
        }}
        className="bg-white rounded-lg border border-gray-200 "
      />

      <EventModal
        open={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};

export default Event;
